<div class="max-w-[1000px] mx-auto min-h-screen flex flex-col items-center justify-center">
  <h1 class="text-hyundai-blue">404</h1>
  <p>Az oldal nem található</p>
</div>
